// src/pages/Projects.js
import React from 'react';
import ProjectsPage from '../components/projects';

/**
 * Projects Page Wrapper
 * This file serves as the page-level component that renders the Projects module
 * Located in pages folder for consistency with routing structure
 */
const Projects = () => {
  return <ProjectsPage />;
};

export default Projects;